import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { GraphDatum } from './_type';

import Arranger from '~c/components/base/arranger';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props extends GraphDatum {
  className?: string;
}

const LegendItemImpl: React.FC<Props> = ({ className, label }) => {
  return (
    <Arranger
      className={className}
      direction="column"
      alignItems="center"
      justify="center"
      sx={{ my: spc.container_padding_s }}
    >
      <div className="dot" />
      <Text sz="body14">{label}</Text>
    </Arranger>
  );
};

export const LegendItem = muiStyled(LegendItemImpl)(
  ({ theme, color }) => css`
    gap: ${theme.spacing(spc.container_padding_s)};

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${color};
    }
  `
);

export default LegendItem;
